function bindZapietEvents() {
    if (window.zapietHandlerBound) return;
    window.zapietHandlerBound = true;

    if (!window.ZapietEvent || !window.ZapietEvent.listen) {
        console.warn('ZapietEvent not available yet. Retrying...');
        setTimeout(bindZapietEvents, 300); // retry after 300ms
        return;
    }

    window.ZapietEvent.listen('selected_method', function(checkout_method) {
        switch (checkout_method) {
            case "pickup":
                console.log('pickup');
                break;
            case "delivery":
                console.log('delivery');
                if ($(`.sundayFriday`).length > 0) {
                    window.ZapietEvent.listen('delivery.datepicker.rendered', function(el) {
                        console.log('delivery.datepicker.rendered');
                        const today = new Date();
                        const dayOfWeek = today.getDay(); // 0 = Sunday
                        const isBeforeSundayMidnight =
                            dayOfWeek < 0 || (dayOfWeek === 0 && (today.getHours() < 23 || (today.getHours() === 23 && today.getMinutes() < 59)));

                        const earliestFriday = new Date(today);
                        var daysToAdd = -(dayOfWeek - 5) % 7; // Always get the closest Friday

                        const lastSunday = new Date(today);
                        lastSunday.setDate(today.getDate() - dayOfWeek); // Go back to the last Sunday
                        lastSunday.setHours(23, 59, 59, 999); // End of Sunday

                        if (today > lastSunday) {
                            console.log("It's past Sunday.");
                            daysToAdd = daysToAdd + 7;
                        } else {
                            console.log("It's not yet Sunday or it's still Sunday.");
                        }

                        earliestFriday.setDate(today.getDate() + daysToAdd);
                        earliestFriday.setHours(0, 0, 0, 0); // Normalize

                        // === Step 1: Clean up previously disabled buttons ===
                        $('.Zapiet-Calendar__Dates .picker__day.jsc-disabled').each(function () {
                            $(this)
                                .removeClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                .removeAttr('aria-disabled');
                        });

                        // Disable calendar days before earliestFriday
                        $('.Zapiet-Calendar__Dates .picker__day').each(function () {
                            const $el = $(this);
                            const ariaLabel = $el.attr('aria-label'); // e.g. "Sun, 29 June, 2025"
                            const match = ariaLabel?.match(/(\d{1,2}) (\w+), (\d{4})$/);
                            if (!match) return;
                    
                            const [_, day, monthName, year] = match;
                            const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
                            const pad = num => String(num).padStart(2, '0');
                            const calendarDate = new Date(`${year}-${pad(monthIndex + 1)}-${pad(day)}`);
                            calendarDate.setHours(0, 0, 0, 0);
                    
                            const isSunday = calendarDate.getDay() === 0;
                            const isBeforeAvailableDate = calendarDate < earliestFriday;
                    
                            // Skip Sundays
                            if (isSunday) return;
                    
                            const isAriaDisabled = $el.attr('aria-disabled') === 'true';
                            const hasDisabledClass = $el.hasClass('disabled') && $el.hasClass('Zapiet-Calendar__Date--disabled') && $el.hasClass('picker__day--disabled');
                    
                            if (isBeforeAvailableDate) {
                                if (!isAriaDisabled) {
                                    $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                        .attr('aria-disabled', 'true');
                                } else if (!hasDisabledClass) {
                                    $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled');
                                }
                            }
                        });

                    });
                    window.ZapietEvent.listen('delivery.datepicker.opened', function(el) {
                        console.log('delivery.datepicker.opened');
                        const today = new Date();
                        const dayOfWeek = today.getDay(); // 0 = Sunday
                        const isBeforeSundayMidnight =
                            dayOfWeek < 0 || (dayOfWeek === 0 && (today.getHours() < 23 || (today.getHours() === 23 && today.getMinutes() < 59)));

                        const earliestFriday = new Date(today);
                        var daysToAdd = -(dayOfWeek - 5) % 7; // Always get the closest Friday

                        const lastSunday = new Date(today);
                        lastSunday.setDate(today.getDate() - dayOfWeek); // Go back to the last Sunday
                        lastSunday.setHours(23, 59, 59, 999); // End of Sunday

                        if (today > lastSunday) {
                            console.log("It's past Sunday.");
                            daysToAdd = daysToAdd + 7;
                        } else {
                            console.log("It's not yet Sunday or it's still Sunday.");
                        }

                        earliestFriday.setDate(today.getDate() + daysToAdd);
                        earliestFriday.setHours(0, 0, 0, 0); // Normalize

                        // === Step 1: Clean up previously disabled buttons ===
                        $('.Zapiet-Calendar__Dates .picker__day.jsc-disabled').each(function () {
                            $(this)
                                .removeClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                .removeAttr('aria-disabled');
                        });

                        // Disable calendar days before earliestFriday
                        $('.Zapiet-Calendar__Dates .picker__day').each(function () {
                            const $el = $(this);
                            const ariaLabel = $el.attr('aria-label'); // e.g. "Sun, 29 June, 2025"
                            const match = ariaLabel?.match(/(\d{1,2}) (\w+), (\d{4})$/);
                            if (!match) return;
                    
                            const [_, day, monthName, year] = match;
                            const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
                            const pad = num => String(num).padStart(2, '0');
                            const calendarDate = new Date(`${year}-${pad(monthIndex + 1)}-${pad(day)}`);
                            calendarDate.setHours(0, 0, 0, 0);
                    
                            const isSunday = calendarDate.getDay() === 0;
                            const isBeforeAvailableDate = calendarDate < earliestFriday;
                    
                            // Skip Sundays
                            if (isSunday) return;
                    
                            const isAriaDisabled = $el.attr('aria-disabled') === 'true';
                            const hasDisabledClass = $el.hasClass('disabled') && $el.hasClass('Zapiet-Calendar__Date--disabled') && $el.hasClass('picker__day--disabled');
                    
                            if (isBeforeAvailableDate) {
                                if (!isAriaDisabled) {
                                    $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                        .attr('aria-disabled', 'true');
                                } else if (!hasDisabledClass) {
                                    $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled');
                                }
                            }
                        });

                    });
                }
                if ($(`.sundayFriday`).length <= 0) {
                    window.ZapietEvent.listen('delivery.datepicker.rendered', function(el) {
                        console.log('delivery.datepicker.rendered');
                        const today = new Date();
                        const dayOfWeek = today.getDay(); // 0 = Sunday
                        const isBeforeSundayMidnight =
                            dayOfWeek < 0 || (dayOfWeek === 0 && (today.getHours() < 23 || (today.getHours() === 23 && today.getMinutes() < 59)));

                        const earliestFriday = new Date(today);
                        var daysToAdd = -(dayOfWeek - 5) % 7; // Always get the closest Friday

                        const lastSunday = new Date(today);
                        lastSunday.setDate(today.getDate() - dayOfWeek); // Go back to the last Sunday
                        lastSunday.setHours(23, 59, 59, 999); // End of Sunday

                        if (today > lastSunday) {
                            console.log("It's past Sunday.");
                            daysToAdd = daysToAdd + 7;
                        } else {
                            console.log("It's not yet Sunday or it's still Sunday.");
                        }

                        earliestFriday.setDate(today.getDate() + daysToAdd);
                        earliestFriday.setHours(0, 0, 0, 0); // Normalize

                        // === Step 1: Clean up previously disabled buttons ===
                        $('.Zapiet-Calendar__Dates .picker__day.jsc-disabled').each(function () {
                            $(this)
                                .removeClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                .removeAttr('aria-disabled');
                        });

                        // Disable calendar days before earliestFriday
                        $('.Zapiet-Calendar__Dates .picker__day').each(function () {
                            const $el = $(this);
                            const ariaSelected = $el.attr('aria-selected');
                            const ariaLabel = $el.attr('aria-label'); // e.g. "Sun, 29 June, 2025"
                            const match = ariaLabel?.match(/(\d{1,2}) (\w+), (\d{4})$/);
                            if (!match) return;
                    
                            const [_, day, monthName, year] = match;
                            const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
                            const pad = num => String(num).padStart(2, '0');
                            const calendarDate = new Date(`${year}-${pad(monthIndex + 1)}-${pad(day)}`);
                            calendarDate.setHours(0, 0, 0, 0);
                    
                            const isSunday = calendarDate.getDay() === 0;
                            const isSaturday = calendarDate.getDay() === 6;
                            const isTodayOrBefore = calendarDate.getTime() <= today.getTime();
                            const isToday = calendarDate.getTime() === today.getTime();

                            if (isTodayOrBefore) {
                                $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                        .attr('aria-disabled', 'true');
                            }

                            if (ariaSelected === 'false') {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }
                    
                            // Skip Sundays
                            if (isSunday) return;
                    
                            if (isSaturday) {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }

                            if (isToday) {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }
                        });

                    });
                    window.ZapietEvent.listen('delivery.datepicker.opened', function(el) {
                        console.log('delivery.datepicker.opened');
                        const today = new Date();
                        const dayOfWeek = today.getDay(); // 0 = Sunday
                        const isBeforeSundayMidnight =
                            dayOfWeek < 0 || (dayOfWeek === 0 && (today.getHours() < 23 || (today.getHours() === 23 && today.getMinutes() < 59)));

                        const earliestFriday = new Date(today);
                        var daysToAdd = -(dayOfWeek - 5) % 7; // Always get the closest Friday

                        const lastSunday = new Date(today);
                        lastSunday.setDate(today.getDate() - dayOfWeek); // Go back to the last Sunday
                        lastSunday.setHours(23, 59, 59, 999); // End of Sunday

                        if (today > lastSunday) {
                            console.log("It's past Sunday.");
                            daysToAdd = daysToAdd + 7;
                        } else {
                            console.log("It's not yet Sunday or it's still Sunday.");
                        }

                        earliestFriday.setDate(today.getDate() + daysToAdd);
                        earliestFriday.setHours(0, 0, 0, 0); // Normalize

                        // === Step 1: Clean up previously disabled buttons ===
                        $('.Zapiet-Calendar__Dates .picker__day.jsc-disabled').each(function () {
                            $(this)
                                .removeClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                .removeAttr('aria-disabled');
                        });

                        // Disable calendar days before earliestFriday
                        $('.Zapiet-Calendar__Dates .picker__day').each(function () {
                            const $el = $(this);
                            const ariaSelected = $el.attr('aria-selected');
                            const ariaLabel = $el.attr('aria-label'); // e.g. "Sun, 29 June, 2025"
                            const match = ariaLabel?.match(/(\d{1,2}) (\w+), (\d{4})$/);
                            if (!match) return;
                    
                            const [_, day, monthName, year] = match;
                            const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
                            const pad = num => String(num).padStart(2, '0');
                            const calendarDate = new Date(`${year}-${pad(monthIndex + 1)}-${pad(day)}`);
                            calendarDate.setHours(0, 0, 0, 0);
                    
                            const isSunday = calendarDate.getDay() === 0;
                            const isSaturday = calendarDate.getDay() === 6;
                            const isTodayOrBefore = calendarDate.getTime() <= today.getTime();
                            const isToday = calendarDate.getTime() === today.getTime();

                            if (isTodayOrBefore) {
                                $el
                                        .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                        .attr('aria-disabled', 'true');
                            }

                            if (ariaSelected === 'false') {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }
                    
                            // Skip Sundays
                            if (isSunday) return;
                    
                            if (isSaturday) {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }

                            if (isToday) {
                                $el
                                    .addClass('disabled Zapiet-Calendar__Date--disabled picker__day--disabled jsc-disabled')
                                    .attr('aria-disabled', 'true');
                                return;
                            }
                        });

                    });
                }
                break;
            case "shipping":
                console.log('shipping');
                break;
        }
    });
}

$(document).ready(bindZapietEvents);
document.addEventListener("shopify:section:load", bindZapietEvents);

$(function(){
    onloadFunctions();
    if (window.location.pathname === '/cart') {
        checkAddOnsWithoutMainProduct();
    }
});

onloadFunctions = () => {
    checkCustomiseIngredients();
    moreVegetablesCustomisation();
    onChangeCalculateTotalPrice();
    kidneySupportLevelCustomisation();
    $('input.jsc-customise-support-levels').on('change', function () {
        kidneySupportLevelCustomisation();
    });
    storeBaseProductPrice();
    loadingSetup();
}

checkCustomiseIngredients = () => {
    // Listen for changes on radio buttons (Customise Ingredients?)
    $('body').on('change', 'input.jsc-customise-ingredients', function() {
        if($('#yes-customise').is(':checked')) {
            console.log('yes');
            const option_html = $('#jsc-customise-options-content').html();
            $('.jsc-customise-options').html(option_html);
            $('.jsc-customise-options').find('input, label, .jsc-customize-questions').each(function() {
                var id = $(this).attr('id');
                if (id) {
                    var newId = id.replace('duplicate-', '');
                    $(this).attr('id', newId);
                }
            });
            kidneySupportLevelCustomisation();
        } else {
            console.log('no');
            $('.jsc-customise-options').children().remove();
        }
    });
}

moreVegetablesCustomisation = () => {
    // Listen for changes on radio buttons (Customise Vegetables?)
    $('body').on('change', '.jsc-customise-options input.jsc-customise-vegetables', function() {
        if ($('.jsc-customise-options #more-customisation').is(':checked')) {
            console.log('more-vegetables-content');
            const more_vegetables_html =  $('#jsc-more-vegetables-content').html();
            $('.jsc-customise-options .jsc-more-vegetables').html(more_vegetables_html);
            $('.jsc-customise-options .jsc-more-vegetables').find('input, label').each(function() {
                var id = $(this).attr('id');
                if (id) {
                    var newId = id.replace('duplicate-', '');
                    $(this).attr('id', newId);
                }
            });
        } else {
            console.log('NOT more-vegetables-content');
            $('.jsc-customise-options .jsc-more-vegetables').children().remove();
        }

        if (!$('.jsc-customise-options #remove-meat-content').is(':checked') && $('#duplicate-jsc-customize-meat').length > 0) {
            console.log('remove-meat-content');
            const meat_content_html =  $('#duplicate-jsc-customize-meat').html();
            $('#jsc-customize-meat').html(meat_content_html);
            $('#jsc-customize-meat').find('input, label').each(function() {
                var id = $(this).attr('id');
                if (id) {
                    var newId = id.replace('duplicate-', '');
                    $(this).attr('id', newId);
                }
            });
        } else {
            console.log('NOT remove-meat-content');
            $('#jsc-customize-meat').children().remove();
        }
        kidneySupportLevelCustomisation();
    });
}

kidneySupportLevelCustomisation = () => {
    const removeEk = $('#remove-component-ek');
    const removeLk = $('#remove-component-lk');

    const ekContainer = $('#jsc-customize-ek');
    const lkContainer = $('#jsc-customize-lk');
    const organsContainer = $('#jsc-customize-organs');
    const meatContainer = $('#jsc-customize-meat');
    const cstQuestionsMeatContentek = $('#duplicate-jsc-customize-meat input:checked');
    const meatContentDataVID= cstQuestionsMeatContentek.attr('data-backup-vid');

    const ekOptionValue = ekContainer.find('input:checked').attr('data-option') || '';
    const lkOptionValue = lkContainer.find('input:checked').attr('data-option') || '';
    const organsOptionValue = organsContainer.find('input:checked').attr('data-option') || '';
    const meatOptionValue = meatContainer.find('input:checked').attr('data-option') || '';
    if (removeEk.is(':checked')) {
        ekContainer.hide().find('input').val('');
        organsContainer.hide().find('input').val('');
        lkContainer.show().find('input:checked').val(lkOptionValue);
        meatContainer.show().find('input:checked').val(meatOptionValue);
        cstQuestionsMeatContentek.attr('data-vid', meatContentDataVID);
    } else if (removeLk.is(':checked')) {
        lkContainer.hide().find('input').val('');
        meatContainer.hide().find('input').val('');
        ekContainer.show().find('input:checked').val(ekOptionValue);
        organsContainer.show().find('input:checked').val(organsOptionValue);
        cstQuestionsMeatContentek.attr('data-vid', '');
    } else {
        $('#jsc-customize-ek, #jsc-customize-lk').hide().find('input').val('');
    }
}

storeBaseProductPrice = () => {
    // Default stored price
    basePriceText = $('.product-block-container .product-block-price span[data-product-price]').text();
    const original_price = parseFloat(basePriceText.replace('$', '').replace('SGD', '').trim()) || 0;
    const stored = $('#base-price-hidden-input');
    
    if (stored && original_price) {
        stored.val(original_price);
    }

    document.addEventListener('sealsubs:price_update', function(e) {
        // Store the base price for calculation use
        const { price } = e.detail;
        const numericValue = parseFloat(price) * 0.01;
        const stored = $('#base-price-hidden-input');
        
        if (stored && !isNaN(numericValue)) {
            stored.val(numericValue);
        }
        stored.attr('data-sealsubs-update', 'true');
    });

    document.addEventListener('theme:variant:change', function(e) {
        // Store the base price for calculation use
        const stored = $('#base-price-hidden-input');

        // Do not trigger when sealsubs update is available
        if (stored.attr('data-sealsubs-update') == 'false') {
            const { price } = e.detail.variant;
            const numericValue = parseFloat(price) * 0.01;
            
            if (stored && !isNaN(numericValue)) {
                stored.val(numericValue);
            }
        }
    });
}

calculateTotalPrice = () => {
    let totalPrice = 0;
    let basePriceText = $('#base-price-hidden-input').val();

    if (isNaN(basePriceText)) {
        basePriceText = $('.product-block-container .product-block-price span[data-product-price]').text();
    }

    const original_price = parseFloat(basePriceText.replace('$', '').replace('SGD', '').trim()) || 0;

    $('form[data-type="add-to-cart-form"] input[type="radio"]:checked[data-price]').each(function() {
        const price = parseFloat($(this).attr('data-price')) || 0;
        totalPrice += price;
    });

    totalPrice = totalPrice + parseFloat(original_price);
    const formattedPrice = '$' + totalPrice.toFixed(2); // + ' SGD'
    $('.product-block-container .product-block-price span[data-product-price]').text(formattedPrice);

    // Update ATC button price
    const atcButton = $('span.jsc-custom-atc');
    if (atcButton.length) {
        const text = atcButton.text();
        
        if (text.includes('$')) {
            const newText = text.replace(/\$.*$/, `$${totalPrice.toFixed(2)}`);
            atcButton.text(newText);
        }
    }
}

onChangeCalculateTotalPrice = () => {
    // Global event listener for all radio changes
    $('body').on('change', 'form[data-type="add-to-cart-form"] input[type="radio"]', function() {
        calculateTotalPrice();
    });

    // Update the price when variant changes
    document.addEventListener('sealsubs:variant_changed', function() {
        setTimeout(() => {
            calculateTotalPrice();
        }, 500);
    });
}

atcAddons = (e) => {
    const _this = $(e);
    const _productForm = _this.closest('form[data-type="add-to-cart-form"]');
    const _addOnsVidEl = _productForm.find(`input:checked[data-vid]`);
    const formData = _productForm.serializeArray(); // serialize form data and convert it to JSON
    const formJson = {};
    var sealSubsType = '';
    formData.forEach(function(field) {
        var key = field.name;
        if (key.startsWith("subs_type")) {
            sealSubsType = key
        }
        formJson[key] = field.value;
    });
    console.log('formJson: ', formJson);
    // console.log('sealSubsType: ', sealSubsType);
    const mainAtcButton = _this.siblings('.jsc-main-atc');

    var itemsArray = [];
    var mainPropertiesHTML = '';
    var addOnsId = '';
    const currentTime = Date.now();
    const purchaseError = _this.siblings('.jsc-min-purchase-error');

    var selectedIngredients = $('input.jsc-customise-ingredients:checked').val();
    // console.log('selectedIngredients: ', selectedIngredients);

    var passMaxSelect = true
    var passMinSelect = true
    if ($(`.jsc-customise-options #more-customisation:checked`).length > 0) {
        const customiseMaxSelect = $(`.jsc-customise-options .jsc-more-vegetables .jsc-max-custom-vege`).attr('data-max-select') ? $(`.jsc-customise-options .jsc-more-vegetables .jsc-max-custom-vege`).attr('data-max-select') : '';
        var checkedCheckboxes = $('.jsc-customise-options input.jsc-vegetable-remove:checked').length;
        if (customiseMaxSelect != '') {
            // console.log('checkedCheckboxes: ', checkedCheckboxes);
            // console.log('parseInt(customiseMaxSelect, 10): ', parseInt(customiseMaxSelect, 10));
            if (checkedCheckboxes <= 0) {
                passMinSelect = false
            }
            if (checkedCheckboxes <= parseInt(customiseMaxSelect, 10)) {
                passMaxSelect = true
            } else {
                passMaxSelect = false
            }
        } else {
            passMaxSelect = true
        }
    }
    console.log('passMaxSelect: ', passMaxSelect);
    console.log('passMinSelect: ', passMinSelect);
    if (passMaxSelect && passMinSelect) {
        $('.jsc-customise-options #jsc-more-vegetables-error').css('display', 'none');
        $('.jsc-customise-options #jsc-more-vegetables-min-error').css('display', 'none');
        if (parseInt(formJson.quantity) >= parseInt(formJson['min-purchase-qty'])){
            purchaseError.css('display', 'none');
            // if (selectedIngredients === 'Yes') { // Customise Ingredients: Yes
                _addOnsVidEl.each(function() {
                    const selectedVid = $(this).attr('data-vid');

                    if (selectedVid) {
                        addOnsId != '' ? addOnsId = addOnsId + '_' + selectedVid : addOnsId = addOnsId + selectedVid

                        var _addOnObjs = {
                            id: selectedVid,
                            quantity: formJson.quantity,
                            properties: {
                                "_bindId": "blank",
                                "_Add_ons": true
                            }
                        }
                        if (formJson.selling_plan && formJson.selling_plan != ''){
                            if (sealSubsType != '') {
                                _addOnObjs['selling_plan'] = formJson.selling_plan;
                                _addOnObjs[sealSubsType] = formJson[sealSubsType];
                                _addOnObjs['subs_interval'] = formJson.subs_interval;
                            } else {
                                _addOnObjs['selling_plan'] = formJson.selling_plan;
                            }
                        }
                        itemsArray.push(_addOnObjs);
                    }
                });

                if (itemsArray.length > 0) {
                    $.each(itemsArray, function(index, item) {
                        item.properties['_bindId'] = `${formJson.id}-${addOnsId}-${currentTime}`;
                    });
                    console.log('itemsArray: ', itemsArray)
                    CartJS.addItems(itemsArray, {
                        "success": function(data, textStatus, jqXHR) {
                            console.log('Success: ', data);
                            mainPropertiesHTML = `<input id="mainProduct" type="hidden" name="properties[_Main_product]" value="true"><input id="bindId" type="hidden" name="properties[_bindId]" value="${formJson.id}-${addOnsId}-${currentTime}">`
                            mainAtcButton.before(mainPropertiesHTML);
                            mainAtcButton.click();
                            updateCart();
                        },
                        "error": function(jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        }
                    });
                } else {
                    mainAtcButton.click();
                    updateCart();
                }
            // } else { // Customise Ingredients: Default (Recommended)
            //     mainAtcButton.click();
            //     updateCart();
            // }
        } else {
            purchaseError.css('display', 'block');
        }
    } else {
        if (!passMaxSelect) {
            $('.jsc-customise-options #jsc-more-vegetables-error').css('display', 'block');
        }
        if (!passMinSelect) {
            $('.jsc-customise-options #jsc-more-vegetables-min-error').css('display', 'block');
        }
        var top = $('.jsc-customise-options #jsc-more-vegetables-error').offset().top - 200;
        window.scrollTo({ top: top, behavior: 'smooth' });
    }
}

updateAddOn = async (addonKeyList, quantity) => {
    console.log('updatingAddOn...: ')
    addonKeyList = addonKeyList != '' ? addonKeyList: '';

    if (addonKeyList) {
        var updateItems = {};
        var addonKeyArray = addonKeyList.split(',').filter(function(key) {
            return key !== '';  // Remove any empty strings resulting from the split
        });
        console.log('addonKeyArray: ', addonKeyArray);
        $.each(addonKeyArray, function(index, key) {
            updateItems[key] = quantity;
        });
        console.log('updateItems: ', updateItems);
        try {
            const response = await CartJS.updateItemQuantitiesById(updateItems);
            console.log('Success: ', response);
            return true;
        } catch (error) {
            console.log('Error: ' + error.message);
            return false;
        }
    } else {
        return true;
    }
}

variantChangeUpdate = (sectionId, variant) => {
    const variantTitle = variant.title
    const splitPackagingEl = $(`#shopify-section-${sectionId}`).find('.jsc-split-packaging');
    if (splitPackagingEl.length > 0 && /^\d/.test(variantTitle)) {
        var currentPackagingSize = variantTitle.match(/^(\d+)g/)[1];
        const minPackagingSize = splitPackagingEl.attr('data-min-size');
        // console.log('minPackagingSize: ', minPackagingSize);
        // console.log('currentPackagingSize: ', currentPackagingSize);
        if (parseInt(currentPackagingSize) >= parseInt(minPackagingSize)) {
            splitPackagingEl.attr('data-expand', 'true');
        } else {
            splitPackagingEl.attr('data-expand', 'false');
            $('#split-packaging-yes').prop('checked', false);
        }
    }
}

checkAddOnsWithoutMainProduct = () => {
    console.log('checkAddOnsWithoutMainProduct...');
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const mainProductBindIds = cart.items
                .filter(item => item.properties && item.properties._Main_product === "true")
                .map(item => item.properties._bindId);

            const orphanedAddons = cart.items
                .filter(item =>
                    item.properties &&
                    item.properties._Add_ons === "true" &&
                    (!item.properties._bindId || !mainProductBindIds.includes(item.properties._bindId))
                );

            if (orphanedAddons.length > 0) {
                const updates = {};
                orphanedAddons.forEach(item => {
                    updates[item.key] = 0;
                });

                CartJS.updateItemQuantitiesById(updates)
                    .then(() => {
                        console.log("Orphaned add-ons removed.");
                        updateCart();
                    });
            }
        });
}

updateCart = () => {
    setTimeout(() => {
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
    }, 200);
}

$(document).ready(function () {
    $('.cartinputqty').on('input', function () {
      var min = parseFloat($(this).attr('min'));
      var val = parseFloat($(this).val());
  
      if (!isNaN(min) && !isNaN(val) && val < min && val !== 0) {
        $(this).val(min);
      }
    });
});

// start: loading indicator
loadingSetup = () => {
    $('.add-to-cart-btn').on('click', function (e) {
        jscStartLoading();
    });
    $(document).on('cart.requestStarted', function(event, cart) {
        jscStartLoading();
    });
}
jscStartLoading = () => {
    if ($('.jsc-page-loading').length) return;
    var $html = `<div class="jsc-page-loading">
                <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                </div>
                </div>`;
    $('body').prepend($html);
}
jscCompleteLoading = () => {
    $('.jsc-page-loading').remove();
}
// end: loading indicator
